module.exports = __webpack_public_path__ + "img/JAM.bf42363d.svg";